import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleNotification";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { receivingStatusFilterOptions } from "../../shared/utility";

// const reportTypeOptions = [
//   { value: 1, label: "Meat Receiving Report" },
//   { value: 2, label: "Non-Meat Receiving Report" },
// ];

export function ReceivingInvoicesViewModel(logout) {
  const [filters, setFilters] = useState({
    supplier: { value: -1, label: "All suppliers" },
    startDate: null,
    endDate: null,
    status: { value: -1, label: "All statuses" },
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [receivingInvoices, setReceivingInvoices] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [reportFilters, setReportFilters] = useState({
    type: { value: -1, label: "Select report" },
    startDate: null,
    endDate: null,
  });
  const [reportInProgress, setReportInProgress] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [suppliers, setSuppliers] = useState([]);

  const getReceivingInvoices = async function (
    search,
    page,
    requestedFilters = filters
  ) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: requestedFilters,
    };
    let callResult = await makePostApiCall(`receivingInvoices`, payload);
    setLoading(false);
    if (callResult.success) {
      setReceivingInvoices(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteReceivingInvoice = async function (invoiceId, index) {
    let callResult = await makePostApiCall(
      `deleteReceivingInvoice/${invoiceId}`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getReceivingInvoices(null, 0);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteReceivingInvoice = function (invoice, index) {
    if (invoice.status === 1) {
      showErrorModal("Cannot delete closed receiving.");
    } else {
      setEmptyModelOpen({
        childComponent: (
          <DeleteConfirmationForm
            buttonMessage="Delete"
            confirmAction={() => deleteReceivingInvoice(invoice.id, index)}
            message={`Are you sure you want to delete invoice ${invoice.invoice_number} from ${invoice.supplier_name}?`}
            setOpen={setEmptyModelOpen}
          />
        ),
        open: true,
      });
    }
  };

  const generateReceivingReport = async function () {
    setReportInProgress(true);
    let callResult = await makePostApiCall(
      `generateReceivingReport`,
      reportFilters,
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setReportInProgress(false);
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() =>
        setFilters({
          ...filters,
          startDate: null,
          endDate: null,
        })
      }
    />,
    <FilterSingleSelectDropdown
      header="Supplier"
      onChange={(value) =>
        setFilters({
          ...filters,
          supplier: value,
        })
      }
      options={suppliers}
      resetFilter={() =>
        setFilters({
          ...filters,
          supplier: { value: -1, label: "All suppliers" },
        })
      }
      valueName="supplier"
      value={filters.supplier}
    />,
    <FilterSingleSelectDropdown
      header="Status"
      onChange={(value) =>
        setFilters({
          ...filters,
          status: value,
        })
      }
      options={receivingStatusFilterOptions}
      resetFilter={() =>
        setFilters({
          ...filters,
          status: { value: -1, label: "All statuses" },
        })
      }
      valueName="status"
      value={filters.status}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      supplier: { value: -1, label: "All suppliers" },
      startDate: null,
      endDate: null,
      status: { value: -1, label: "All statuses" },
    };
    setFilters(filterReset);

    setShowFilters(false);
    getReceivingInvoices(null, 1, filterReset);
  };

  const getSuppliers = async function () {
    let callResult = await makeGetApiCall(`suppliersForDropdown`);
    if (callResult.success) {
      setSuppliers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteReceivingInvoice,
    emptyModal,
    getReceivingInvoices,
    loading,
    receivingInvoices,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    getSuppliers,
    showErrorModal,
  };
}
